import { memo, useCallback, useEffect } from 'react';

import { AuthService } from 'shared/config/oidcClient/authServices';

export const LoginRedirectPage = memo(() => {
  const onLogin = useCallback(async () => {
    try {
      const authService = new AuthService();
      await authService.login();
    } catch (error) {
      console.error('Login redirect error:', error);
    }
  }, []);

  useEffect(() => {
    onLogin();
  }, [onLogin]);

  return <></>;
});
